import validatePhoneNumber from 'Utils/validatePhoneNumber';

export const getFirstParticipantPhone = (phones) => {
  const phoneTypes = Object.keys(phones);
  for (const type of phoneTypes) {
    const phone = phones[type];
    const { areaCode, number } = phone;
    
    if (areaCode && number && validatePhoneNumber(phone, phone.type)) {
      return phone;
    }
  }
  return null;
};
